__turbopack_context__.v({
  "paddingOverride": "FAQSection-module__0vYlha__paddingOverride",
  "seeAllRow": "FAQSection-module__0vYlha__seeAllRow",
});
